import React from "react";
import { useLanguage } from "../../i18n";
import type { LedgerCharge } from "../../api";

function fmtINR(n: number) {
  return "₹" + Number(n).toLocaleString("en-IN");
}

const KIND_KEY: Record<LedgerCharge["kind"], string> = {
  electricity: "charges.electricity",
  late_fee: "charges.lateFee",
  other: "charges.other",
};

// The rent-plus-extras breakdown behind a month's total. Renders nothing for
// a plain rent-only month, so callers can drop it in unconditionally. When
// onRemove is passed (owner, unpaid month) each extra gets a remove button.
export function ChargeLines({
  rentAmount,
  charges,
  total,
  onRemove,
}: {
  rentAmount?: number;
  charges?: LedgerCharge[];
  total: number;
  onRemove?: (chargeId: string) => void;
}) {
  const { t } = useLanguage();
  if (!charges || charges.length === 0) return null;
  const row: React.CSSProperties = { display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, padding: "3px 0" };
  return (
    <div style={{ marginTop: 10, paddingTop: 8, borderTop: "1px dashed var(--line)" }}>
      <div style={row}>
        <span className="sub">{t("charges.rent")}</span>
        <span>{fmtINR(rentAmount ?? total - charges.reduce((s, c) => s + c.amount, 0))}</span>
      </div>
      {charges.map((c) => (
        <div key={c.id} style={row}>
          <span className="sub">
            {c.label || t(KIND_KEY[c.kind])}
            {onRemove && (
              <button
                type="button"
                className="link-btn"
                style={{ marginLeft: 8, fontSize: 12 }}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(c.id);
                }}
              >
                {t("charges.remove")}
              </button>
            )}
          </span>
          <span>{fmtINR(c.amount)}</span>
        </div>
      ))}
      <div style={{ ...row, fontWeight: 800 }}>
        <span>{t("charges.total")}</span>
        <span>{fmtINR(total)}</span>
      </div>
    </div>
  );
}
